<app-breadcrumb [title]="'Registro de siniestro vial'" [items]="['Seguridad Vial']"
  [active_item]="'Nuevo siniestro'"></app-breadcrumb>

<div class="container-fluid">

  <!-- Card 1: Información general -->
  <div class="card mb-3">
    <div class="card-header bg-primary text-white">
      <strong>1. INFORMACIÓN GENERAL</strong>
    </div>
    <div class="card-body">
      <form [formGroup]="formSiniestro">
        <div class="row g-3 mb-4">
          <div class="col-md-3">
            <label class="form-label text-dark">
              Consecutivo: <a class="text-danger"> *</a>
            </label>
            <input type="text" class="form-control" formControlName="consecutivo" readonly />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Fecha del siniestro: <a class="text-danger"> *</a></label>
            <input type="date" class="form-control" placeholder="Ingrese la fecha" formControlName="fecha_siniestro"
              [attr.max]="hoy" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Hora del siniestro: <a class="text-danger"> *</a></label>
            <input type="time" class="form-control" placeholder="Ingrese la hora" formControlName="hora_siniestro" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Fecha del reporte: <a class="text-danger"> *</a></label>
            <input type="date" class="form-control" placeholder="Ingrese la fecha" formControlName="fecha_reporte"
              [attr.max]="hoy" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Hora del reporte: <a class="text-danger"> *</a></label>
            <input type="time" class="form-control" placeholder="Ingrese la hora" formControlName="hora_reporte" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Tipo de siniestro: <a class="text-danger"> *</a></label>
            <ng-select [items]="tiposSiniestro" placeholder="Seleccione el tipo de siniestro" bindLabel="nombre"
              bindValue="id" formControlName="tipo_siniestro"></ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Nivel de severidad: <a class="text-danger"> *</a></label>
            <ng-select [items]="nivelesSeveridad" placeholder="Seleccione el nivel de severidad" bindLabel="nombre"
              bindValue="id" formControlName="nivel_severidad"></ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Lesionados: <a class="text-danger"> *</a></label>
            <input type="number" class="form-control" placeholder="Ingrese el número de lesionados"
              formControlName="lesionados" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Fatalidad: <a class="text-danger"> *</a></label>
            <input type="number" class="form-control" placeholder="Ingrese el número de fatalidades"
              formControlName="fatalidad" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Número de víctimas: <a class="text-danger"> *</a></label>
            <input type="number" class="form-control" placeholder="Ingrese el número de víctimas"
              formControlName="numero_victimas" />
          </div>
          <div class="col-md-12">
            <label class="form-label text-dark">Descripción: <a class="text-danger"> *</a></label>
            <textarea class="form-control" rows="3" placeholder="Ingrese la descripción del siniestro"
              formControlName="descripcion_ocurrido"></textarea>
          </div>
        </div>
      </form>
    </div>
  </div>

  <!-- Card 2: Lugar -->
  <div class="card mb-3">
    <div class="card-header bg-primary text-white">
      <strong>2. LUGAR DEL SINIESTRO</strong>
    </div>
    <div class="card-body">
      <form [formGroup]="formSiniestro">
        <div class="row g-3 mb-4">
          <div class="col-md-3">
            <label class="form-label text-dark">Municipio: <a class="text-danger"> *</a></label>
            <ng-select [items]="municipios" placeholder="Seleccione el municipio" bindLabel="MUNICIPIO"
              bindValue="IDMUN" formControlName="municipio" (change)="onMunicipioChange($event)">
              <ng-template ng-label-tmp let-item="item">
                {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
              </ng-template>
              <ng-template ng-option-tmp let-item="item">
                {{ item.MUNICIPIO }} ({{ item.departamento?.nombre }})
              </ng-template>
            </ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Departamento: <a class="text-danger"> *</a></label>
            <ng-select [items]="departamentos" placeholder="Seleccione el departamento" bindLabel="nombre"
              bindValue="id" formControlName="departamento"></ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Dirección / Referencia: <a class="text-danger"> *</a></label>
            <input type="text" class="form-control" placeholder="Ingrese la dirección de referencia"
              formControlName="direccion_referencia" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Latitud:</label>
            <input type="number" class="form-control" placeholder="Ingrese la latitud"
              formControlName="coordenadas_latitud" (input)="updateMap()" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Longitud:</label>
            <input type="number" class="form-control" placeholder="Ingrese la longitud"
              formControlName="coordenadas_longitud" (input)="updateMap()" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Ruta / Trayecto:</label>
            <input type="text" class="form-control" placeholder="Ingrese la ruta o trayecto"
              formControlName="ruta_trayecto" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Vía:</label>
            <ng-select [items]="vias" placeholder="Seleccione la vía" bindLabel="nombre" bindValue="id"
              formControlName="via"></ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Condiciones climáticas:</label>
            <ng-select [items]="condicionesClimaticas" placeholder="Seleccione las condiciones climáticas"
              bindLabel="nombre" bindValue="id" formControlName="condiciones_climaticas"></ng-select>
          </div>
          <div class="col-md-12 mt-3" *ngIf="mapUrl">
            <iframe width="100%" height="300" frameborder="0" [src]="mapUrl | safeUrl">
            </iframe>
          </div>

        </div>
      </form>
    </div>
  </div>

  <!-- Card 3: Vehículo -->
  <div class="card mb-3">
    <div class="card-header bg-primary text-white">
      <strong>3. INFORMACIÓN DEL VEHÍCULO</strong>
    </div>
    <div class="card-body">
      <form [formGroup]="formSiniestro">
        <div class="row g-3 mb-4">
          <div class="col-md-3">
            <label class="form-label text-dark">Placa: <a class="text-danger"> *</a></label>
            <div class="input-group">
              <input type="text" class="form-control text-uppercase" placeholder="Ingrese la placa"
                formControlName="placa" maxlength="7" />
              <button type="button" class="btn btn-primary" (click)="buscarVehiculoPorPlaca()">
                <i class="icofont icofont-search"></i>
              </button>
            </div>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Tipo de vehículo: <a class="text-danger"> *</a></label>
            <ng-select [items]="tiposVehiculo" bindLabel="tipos" placeholder="Seleccione el tipo de vehículo"
              bindValue="idTipos" formControlName="tipo_vehiculo"></ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Marca: <a class="text-danger"> *</a></label>
            <ng-select [items]="marcasVehiculo" bindLabel="marca" placeholder="Seleccione la marca" bindValue="id"
              formControlName="marca"></ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Línea: <a class="text-danger"> *</a></label>
            <input type="text" class="form-control" placeholder="Ingrese la línea" formControlName="linea" />
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Modelo: <a class="text-danger"> *</a></label>
            <ng-select [items]="modelosVehiculo" bindLabel="modelo" placeholder="Seleccione el modelo" bindValue="id"
              formControlName="modelo"></ng-select>
          </div>
          <div class="col-md-3">
            <label class="form-label text-dark">Relación: <a class="text-danger"> *</a></label>
            <ng-select [items]="propiedadesVehiculo" bindLabel="relacion" bindValue="id"
              placeholder="Seleccione la relación" formControlName="propiedad_vehiculo"></ng-select>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="card mb-3">
    <div class="card-header bg-primary text-white">
      <strong>4. CONDUCTOR INVOLUCRADO</strong>
    </div>
    <div class="card-body">
      <form [formGroup]="formConductorInvolucrado">
        <div class="row g-3 mb-4">

          <div class="col-md-3">
            <label class="form-label text-dark">Nombre Conductor: <a class="text-danger"> *</a></label>
            <ng-select [items]="conductoresPorPlaca" bindLabel="nombreCompleto" formControlName="nombre"
              placeholder="Seleccione el conductor" (change)="onConductorSeleccionado($event)">

              <!-- Etiqueta que se muestra en el campo cuando seleccionas -->
              <ng-template ng-label-tmp let-item="item">
                {{ item.propietario.primernombre }} {{ item.propietario.segundonombre }}
                {{ item.propietario.papellidos }} {{ item.propietario.seapellidos }}
              </ng-template>

              <!-- Etiqueta que se muestra en las opciones -->
              <ng-template ng-option-tmp let-item="item">
                {{ item.propietario.primernombre }} {{ item.propietario.segundonombre }}
                {{ item.propietario.papellidos }} {{ item.propietario.seapellidos }}
              </ng-template>
            </ng-select>

          </div>


          <div class="col-md-3">
            <label class="form-label text-dark">Tipo de Documento: <a class="text-danger"> *</a></label>
            <ng-select [items]="Tiposdocumentos" bindLabel="label" bindValue="value" formControlName="tipodocumento"
              placeholder="Seleccione tipo de documento">
            </ng-select>
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">N° Documento: <a class="text-danger"> *</a></label>
            <input type="number" class="form-control" formControlName="n_documento"
              placeholder="Ingrese el número de documento" />
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Rol en el Siniestro: <a class="text-danger"> *</a></label>
            <ng-select [items]="tiposActorVial"  bindLabel="descripcion" bindValue="id" formControlName="rol_siniestro"
              placeholder="Seleccione rol">
            </ng-select>
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Fecha de nacimiento: <a class="text-danger"> *</a></label>
            <input type="date" class="form-control" formControlName="fecha_nacimiento" />
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Estado en el momento: <a class="text-danger"> *</a></label>
            <ng-select [items]="estadoConductor" bindLabel="descripcion" bindValue="id"
              formControlName="estado_momento_siniestro" placeholder="Seleccione el estado">
            </ng-select>
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Categoría: <a class="text-danger"> *</a></label>
            <ng-select [items]="Categoria" bindLabel="label" bindValue="value" formControlName="categoria"
              placeholder="Selecciona la categoría">
            </ng-select>
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">N° Licencia: <a class="text-danger"> *</a></label>
            <input type="number" class="form-control" formControlName="n_licencia"
              placeholder="Ingrese el numero de Licencia" />
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Fecha expedición: <a class="text-danger"> *</a></label>
            <input type="date" class="form-control" formControlName="fecha_expedicion" />
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Fecha vencimiento: <a class="text-danger"> *</a></label>
            <input type="date" class="form-control" formControlName="fecha_vencimiento" />
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Usaba cinturón: <a class="text-danger"> *</a></label>
            <ng-select [items]="[{id:1,descripcion:'Sí'},{id:0,descripcion:'No'}]" bindLabel="descripcion"
              bindValue="id" formControlName="usaba_cinturon">
            </ng-select>
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Misión laboral: <a class="text-danger"> *</a></label>
            <ng-select [items]="[{id:1,descripcion:'Sí'},{id:0,descripcion:'No'}]" bindLabel="descripcion"
              bindValue="id" formControlName="mision_laboral">
            </ng-select>
          </div>

        </div>
        <button type="button" class="btn btn-primary" (click)="agregarConductor()">Agregar conductor</button>
      </form>

      <div class="card-body" *ngIf="conductoresInvolucrados.length > 0">
        <h5>Listado de conductores agregados</h5>
        <table class="table table-bordered">
          <thead>
            <tr>
              <th>Nombre</th>
              <th>Documento</th>
              <th>Rol</th>
              <th>Fecha nacimiento</th>
              <th>Estado</th>
              <th>Categoría</th>
              <th>Licencia</th>
              <th>Cinturón</th>
              <th>Misión laboral</th>
              <th>Acciones</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let c of conductoresInvolucrados; let i=index">
              <td>{{c.nombre}}</td>
              <td>{{c.n_documento}}</td>
              <td>{{c.rol_siniestro}}</td>
              <td>{{c.fecha_nacimiento}}</td>
              <td>{{c.estado_momento_siniestro}}</td>
              <td>{{c.categoria}}</td>
              <td>{{c.n_licencia}}</td>
              <td>{{c.usaba_cinturon == 1 ? 'Sí' : 'No'}}</td>
              <td>{{c.mision_laboral == 1 ? 'Sí' : 'No'}}</td>
              <td>
                <button class="btn btn-danger btn-sm" (click)="eliminarConductor(i)">Eliminar</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>


    </div>
  </div>

  <div class="card mb-3">
    <div class="card-header bg-primary text-white">
      <strong>5. VEHÍCULO INVOLUCRADO</strong>
    </div>
    <div class="card-body">
      <form [formGroup]="formVehiculoInvolucrado">
        <div class="row g-3 mb-4">

          <div class="col-md-3">
            <label class="form-label text-dark">Placa: <a class="text-danger">*</a></label>
            <input type="text" class="form-control" formControlName="placa_involucrado" maxlength="7"
              placeholder="Ingrese la placa" />
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Número interno:</label>
            <input type="text" class="form-control" formControlName="numero_interno" placeholder="Número interno" />
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Tipo de vehículo: <a class="text-danger">*</a></label>
            <ng-select [items]="tiposVehiculo" bindLabel="tipos" bindValue="idTipos" formControlName="tipo_vehiculo"
              placeholder="Seleccione tipo de vehículo">
            </ng-select>
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Propiedad del vehículo: <a class="text-danger">*</a></label>
            <ng-select [items]="propiedadesVehiculo" bindLabel="relacion" bindValue="id"
              formControlName="propiedad_vehiculo" placeholder="Seleccione propiedad">
            </ng-select>
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Fecha vencimiento SOAT: <a class="text-danger">*</a></label>
            <input type="date" class="form-control" formControlName="fecha_vencimiento" />
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Revisión tecnomecánica: <a class="text-danger">*</a></label>
            <input type="date" class="form-control" formControlName="revision_tecnomecanica" />
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Carga:</label>
            <input type="number" class="form-control" formControlName="carga" placeholder="Ingrese carga (kg)" />
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Descripción carga:</label>
            <input type="text" class="form-control" formControlName="descripcion_carga"
              placeholder="Descripción de la carga" />
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Empresa transportadora:</label>
            <input type="text" class="form-control" formControlName="empresa_transportadora"
              placeholder="Nombre empresa" />
          </div>

        </div>
        <button type="button" class="btn btn-primary" (click)="agregarVehiculo()">Agregar vehículo</button>
      </form>



      <div class="card-body" *ngIf="vehiculosInvolucrados.length > 0">
        <h5>Listado de vehículos agregados</h5>

        <table class="table table-bordered">
          <thead>
            <tr>
              <th>PLACA</th>
              <th>TIPO</th>
              <th>PROPIEDAD</th>
              <th>SOAT</th>
              <th>TECNOMECANICA</th>
              <th>CARGA</th>
              <th>EMPRESA</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let v of vehiculosInvolucrados; let i=index">
              <td>{{v.placa}}</td>
              <td>
                {{ getNombreTipoVehiculo(v.tipo_vehiculo) }}
              </td>
              <td>
                {{ getNombrePropiedadVehiculo(v.propiedad_vehiculo) }}
              </td>
              <td>{{v.fecha_vencimiento}}</td>
              <td>{{v.revision_tecnomecanica}}</td>
              <td>{{v.carga}} kg</td>
              <td>{{v.empresa_transportadora || 'N/A'}}</td>
              <td>
                <button class="btn btn-danger btn-sm" (click)="eliminarVehiculo(i)">
                  Eliminar
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="card mb-3">
    <div class="card-header bg-primary text-white">
      <strong>6. OTROS INVOLUCRADOS</strong>
    </div>
    <div class="card-body">
      <form [formGroup]="formOtrosInvolucrado">
        <div class="row g-3 mb-4">
          <div class="col-md-3">
            <label class="form-label text-dark">Tipo de actor vial: <a class="text-danger">*</a></label>
            <ng-select [items]="tiposActorVial" bindLabel="descripcion" bindValue="id" formControlName="tipo_actor_vial"
              placeholder="Seleccione tipo de actor vial">
            </ng-select>
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Nombre: <a class="text-danger">*</a></label>
            <input type="text" class="form-control" formControlName="nombre" placeholder="Ingrese el nombre" />
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Documento: <a class="text-danger">*</a></label>
            <input type="number" class="form-control" formControlName="n_documento" placeholder="Documento" />
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Placa: <a class="text-danger">*</a></label>
            <input type="text" class="form-control text-uppercase" formControlName="placa" placeholder="Placa"
              maxlength="7" />
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Lesiones:</label>
            <ng-select [items]="opcionesSiNo" bindLabel="descripcion" bindValue="id" formControlName="lesiones"
              placeholder="Seleccione">
            </ng-select>
          </div>

          <div class="col-md-3">
            <label class="form-label text-dark">Daños:</label>
            <ng-select [items]="opcionesSiNo" bindLabel="descripcion" bindValue="id" formControlName="danos"
              placeholder="Seleccione">
            </ng-select>
          </div>
        </div>
        <div class="text-start">
          <button type="button" class="btn btn-primary" (click)="agregarOtroInvolucrado()">
            <i class="icofont icofont-plus"></i> Agregar otro involucrado
          </button>
        </div>
      </form>

      <div class="mt-4" *ngIf="otrosInvolucrados.length > 0">
        <h5 class="mb-3">Listado de otros involucrados</h5>
        <div class="table-responsive">
          <table class="table table-bordered table-sm mb-0">
            <thead class="table-light">
              <tr>
                <th>Tipo actor</th>
                <th>Nombre</th>
                <th>Documento</th>
                <th>Placa</th>
                <th>Lesiones</th>
                <th>Daños</th>
                <th class="text-center">Acciones</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let otro of otrosInvolucrados; let i=index">
                <td>{{ otro.tipo_actor_vial }}</td>
                <td>{{ otro.nombre }}</td>
                <td>{{ otro.n_documento }}</td>
                <td>{{ otro.placa }}</td>
                <td>{{ otro.lesiones == 1 ? 'Sí' : 'No' }}</td>
                <td>{{ otro.danos == 1 ? 'Sí' : 'No' }}</td>
                <td class="text-center">
                  <button class="btn btn-danger btn-sm" (click)="eliminarOtroInvolucrado(i)">Eliminar</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>

  <!-- Card 7: Soporte Digital -->
  <div class="card mb-3 shadow-sm">
  <div class="card-header bg-primary text-white">
    <strong>7. SOPORTE DIGITAL</strong>
  </div>

 <div class="card-body">
  <div class="upload-card">
    <div class="row">
      <div
        class="col-md-3 col-sm-4 col-6 mb-3"
        *ngFor="let archivo of archivosSeleccionados; let i = index">

        <div class="border rounded p-2 text-center h-100">
          <!-- Imagen -->
          <img *ngIf="previews[i]" [src]="previews[i]" class="preview-image img-fluid mb-2">

          <!-- PDF -->
          <div *ngIf="!previews[i]" class="pdf-preview mb-2">
            <i class="icofont icofont-file-pdf" style="font-size:50px;color:#dc3545;"></i>
          </div>

          <div class="small text-truncate mb-2">
            <strong>Documento {{ i + 1 }}: {{ archivo.name }}</strong>
          </div>

          <button type="button" class="btn btn-outline-danger btn-sm" (click)="eliminarDocumento(i)">
            <i class="icofont icofont-trash"></i>
          </button>
        </div>
      </div>
    </div>

    <!-- Botón para agregar otro archivo -->
    <div class="text-center mt-3">
      <input type="file" id="archivoSiniestro" class="d-none" accept="image/*,.pdf" (change)="onFileSelected($event)">
      <label for="archivoSiniestro" class="btn btn-outline-primary" >
        <i class="icofont icofont-plus"></i> Agregar documento
      </label>
    </div>
  </div>
</div>

</div>

  <!-- Botones -->
  <div class="text-center my-4">
    <button class="btn btn-primary" type="submit" (click)="guardar()">
      <i class="icofont icofont-save"></i> Guardar
    </button>
  </div>

</div>